/**
 * Telegram bot/channel identity API client (BFF: `/api/v1/store/settings/telegram/channel`).
 *
 * Bot identity, Mini App, and support/FAQ feature flags for the Telegram channel —
 * decoupled from `MaxSettings` (gap G1). The bot token and webhook secret are
 * write-only and never returned on read.
 */
import { apiClient } from '@/shared/api';
import type {
  TelegramChannelSettings,
  UpdateTelegramChannelSettingsRequest,
} from '../model/settingsTypes';

const BASE = '/api/v1/store/settings/telegram/channel';

export const getTelegramChannelSettings = async (): Promise<TelegramChannelSettings> =>
  (await apiClient.get<TelegramChannelSettings>(BASE)).data;

export const updateTelegramChannelSettings = async (
  body: UpdateTelegramChannelSettingsRequest,
): Promise<TelegramChannelSettings> =>
  (await apiClient.put<TelegramChannelSettings>(BASE, body)).data;
